
import { defineComponent } from "vue"
import type { ProgramEvent, FullProgramEvent } from "@/types/api/program"

export default defineComponent({
  props: {
    event: {
      type: Object as VuePropType<ProgramEvent | FullProgramEvent>,
      required: true,
    },
  },

  data () {
    return {
      isVoted: this.event.isVoted,
      votes: this.event.votes,
    }
  },

  methods: {
    async vote () {
      if (this.isVoted) return

      if (!this.$auth.loggedIn) {
        this.$router.push("/auth/login")
        return
      }

      this.isVoted = true
      this.votes++

      const [, err] = await this.$api.program.addEventVote(this.event.id)

      if (err) {
        this.isVoted = false
        this.votes--

        console.error(err.message)
      }
    },
  },
})
